var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3333C1.45 13.3333 0.979167 13.1514 0.5875 12.7877C0.195833 12.424 0 11.9868 0 11.4761V5.90468C0 5.71897 0.0416667 5.54099 0.125 5.37075C0.208333 5.20051 0.316667 5.05349 0.45 4.92968L5.4 0.333252L6.15 1.02968C6.25 1.12254 6.33333 1.24248 6.4 1.3895C6.46667 1.53653 6.5 1.67968 6.5 1.81897V2.00468L5.8 4.97611H11C11.2833 4.97611 11.5208 5.0651 11.7125 5.24307C11.9042 5.42105 12 5.64159 12 5.90468V7.06539C12 7.15825 11.9917 7.24724 11.975 7.33236C11.9583 7.41748 11.9333 7.49873 11.9 7.57611L9.65 12.4975C9.53333 12.7606 9.34583 12.9657 9.0875 13.1127C8.82917 13.2597 8.55 13.3333 8.25 13.3333H2ZM7.95 11.4761L10 6.97254V6.83325H3.35L3.95 4.32611L2 6.09039V11.4761H7.95Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.6bca3343a1587461f43e76893020dea4.svg";
export { ForwardRef as ReactComponent };